import classNames from "classnames";

const InfoBox = ({ icon, content, variant = "info", className, onClick }) => {
  return (
    <div
      className={classNames("infoBox", `infoBox--${variant}`, className)}
      onClick={onClick}
    >
      {icon && (
        <div className="infoBox--icon">
          {typeof icon === "string" ? <img src={icon} alt="icon" /> : icon}
        </div>
      )}
      <div className="infoBox--content">{content}</div>
    </div>
  );
};

export default InfoBox;
